import React from 'react';

const ImagePreview = ({ url }) => {
  return <img src={url} alt='preview' />;
};

export default ImagePreview;
